import Script from 'next/script'

const getAnalyticsTag = () => {
  return {
    __html: `
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?407a3951db51470636cda2f9da608fe1";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();`,
  }
}

export const AnalyticsScript: React.FC = () => {
  return (
    <Script
      id="baiduanalyticstag"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={getAnalyticsTag()}
    />
  )
}
